import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProteccionDatosComponent } from '../proteccion-datos/proteccion-datos.component';
import { TecnologiaTcComponent } from '../tecnologia-tc/tecnologia-tc.component';

declare var fbq;
declare var gtag;

@Component({
  selector: 'app-bici-legales',
  templateUrl: './bici-legales.component.html',
  styleUrls: ['./bici-legales.component.css']
})
export class BiciLegalesComponent implements OnInit {

  path: any = "";
  fechasDisclaimer: any = {};
  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
  ) { 
    this.path = this.route.routeConfig.path;
    this.api.getFechasDisclaimer().subscribe(response => {
      this.fechasDisclaimer.fechaInicio = new Date(response.data.fecha_inicio);
      this.fechasDisclaimer.fechaFin = new Date(response.data.fecha_fin);
    });

  }

  ngOnInit() {
  }

  showProteccionDatos(type:string = "bi") {
    this.modalService.open(ProteccionDatosComponent, { size: <any>'tecno-proteccion-datos ' + <any>type });
  }

  showTC(type:string = "bi") {
    this.modalService.open(TecnologiaTcComponent, { size: <any>'tecno-proteccion-datos ' + <any>type });
  }

  trackEvent(gAction = null, gCategory = "", gLabel = "", FbEvent = null) {
    console.log("Categoria: " + gCategory + " | Accion: " + gAction + " | Etiqueta: " + gLabel);

    if (gAction) {
      gtag('event', gAction, {
        'event_category': gCategory,
        'event_label': gLabel
      });
    }

    if (FbEvent) {
      fbq('track', FbEvent);
    }
  }
  
}
